/**
 * TASKS-ALL.ROUTE
 * Get all action plans for manager
 */
import PageHeader from "@/components/page-header"
import NavApp from "@/nav/nav.app"
import { WithTranslation, withTranslation } from "react-i18next"
import Button from "@/components/button"
import TasksAllWidget from "@/widgets/tasks-all.widget"
import { useState } from "react"

function TasksAllRoute(props: WithTranslation) {
  const { t } = props

  const [exportRequested, setExportRequested] = useState(false)

  function handleExport() {
    setExportRequested(true)
  }

  return (
    <NavApp>
      <PageHeader title={t("tasks_actions_all")} subtitle={t("tasks_actions_all_help")}>
        <Button isFullWidth className="primary" onClick={() => handleExport()}>
          {t("utils_export")}
        </Button>
      </PageHeader>
      <TasksAllWidget exportRequested={exportRequested} onExportClose={() => setExportRequested(false)} />
    </NavApp>
  )
}

export default withTranslation()(TasksAllRoute)
